import { useLoading } from '@ppvrbh/merchant-frontend-core';
import React from 'react';
import { useSelector } from 'react-redux';
import { MAIN_STATE_KEY, mainStateSelector } from '../../main/main-reducer';
import { RBHBox, RBHImage } from '../../shared/components';
import { Images } from '../../shared/theme';
import styles from './styles';

export const Loading: React.FC<Props> = () => {
  const isLoading = useLoading();
  // Tasks that are not a http call
  const mainLoadings = useSelector(mainStateSelector(MAIN_STATE_KEY.LOADING)) || [];

  if (isLoading || Object.keys(mainLoadings).length > 0) {
    return (
      <RBHBox style={styles.loadingDefault}>
        <RBHImage id={'id-loading'} src={Images.iconLoading} style={styles.iconLoading} />
      </RBHBox >
    );
  } else {
    return (null);
  }
};

type Props = {

};
